import domToImage from "dom-to-image-more";
import { useState } from "react";
import { useEffectOnce } from "usehooks-ts";

export function useThumbnail(node: HTMLElement | null, delay = 500) {
  const [thumbnail, setThumbnail] = useState("");
  const [error, setError] = useState(false);
  useEffectOnce(() => {
    if (!node) return;
    setTimeout(() => {
      requestAnimationFrame(() => {
        try {
          domToImage
            .toPng(node, {
              quality: 0.25,
              filter(node) {
                return !(
                  node.nodeName === "IMG" &&
                  (node as HTMLImageElement).src.startsWith("http")
                );
              },
            })
            .then((dataUrl: string) =>
              resizeBase64Image(dataUrl, 160 * 2, 90 * 2)
                .then((dataUrl) => setThumbnail(dataUrl))
                .catch(() => setError(true))
            )
            .catch(() => setError(true));
        } catch {
          setError(true);
        }
      });
    }, delay);
  });
  return { thumbnail, error };
}

function resizeBase64Image(
  base64: string,
  width: number,
  height: number
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;
    img.addEventListener("load", () => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
        const resizedBase64 = canvas.toDataURL();
        resolve(resizedBase64);
      } else {
        reject(new Error("Could not get canvas context"));
      }
    });
    img.addEventListener("error", (error) => reject(error));
  });
}
